import axios from 'axios'
let domain = 'https://mdpcs.urlaubsgutschein.kaufen' // 'http://localhost:8085' //
export const getDomain = () => {
  return domain
}
export const setDomain = $domain => {
  domain = $domain
}

const getPages = async () => {
  const domain = getDomain()
  let {data} = await axios.get(`${domain}/api/content/pages`)
  return data
}

const getTopExtensionPoint = async () => {
  const domain = getDomain()
  let {data} = await axios.get(`${domain}/api/content/top`)
  return data
}

const getFooterExtensionPoint = async () => {
  const domain = getDomain()
  let {data} = await axios.get(`${domain}/api/content/footer`)
  return data
}

const getHome = async () => {
  const domain = getDomain()
  let {data} = await axios.get(`${domain}/api/content/home`)
  return data
}

const getPage = async (locale, name) => {
  const domain = getDomain()
  let {data} = await axios.get(`${domain}/api/content/page/${locale}/${name}`)
  return data
}

const savePage = async mdPage => {
  const domain = getDomain()
  let {data} = await axios.post(
    `${domain}/api/content/page`,
    JSON.stringify(mdPage),
  )
  return data
}

const saveTop = async content => {
  const domain = getDomain()
  let {data} = await axios.put(
    `${domain}/api/content/top`,
    JSON.stringify(content),
  )
  return data
}

const saveFooter = async content => {
  const domain = getDomain()
  let {data} = await axios.put(
    `${domain}/api/content/footer`,
    JSON.stringify(content),
  )
  return data
}

const saveHome = async content => {
  const domain = getDomain()
  let {data} = await axios.put(
    `${domain}/api/content/home`,
    JSON.stringify(content),
  )
  return data
}

export default {
  getPages,
  getPage,
  savePage,
  getTopExtensionPoint,
  getFooterExtensionPoint,
  getHome,
  saveTop,
  saveFooter,
  saveHome,
}
